/**
 * "Naručioci" grupne firme (telefon i računar): radnici jedne smene sa obrocima po grupama jela i napomenom,
 * zbir po grupi jela. Zahteva nasleđen stari tab tabs/CompanyReportTabCustomers (customers, totals, search,
 * mealCategories, filters). Pretraga iz zajedničke trake (store) se prosleđuje starom polju `search` (on je
 * odlaže 300 ms), pa i štampa/Excel prate ono što se vidi. Radi samo za jedan dan.
 */
export default {
  computed: {
    isRange() {
      const { from, to } = this.filters.dates;
      return Boolean(to && from !== to);
    },
    rows() {
      if (this.isRange) {
        return [];
      }
      return this.customers
        .map((customer) => {
          const cells = {};
          this.mealCategories.forEach((category) => {
            cells[category] = (customer[category] || []).map((meal) => ({
              quantity: meal.quantity,
              name: this.toLatin(meal.name || ""),
            }));
          });
          return {
            key: [customer.userId, customer.date, customer.shift].join("|"),
            userId: customer.userId,
            fullname: customer.fullname,
            note: customer.note,
            cells,
          };
        })
        .sort((a, b) => a.fullname.localeCompare(b.fullname));
    },
    mealTotal() {
      return this.mealCategories.reduce((sum, category) => sum + (this.totals[category] || 0), 0);
    },
  },
  watch: {
    "filters.search": {
      handler(value) {
        this.search = value || "";
      },
      immediate: true,
    },
  },
};
